var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{on:{"close":function($event){return _vm.$emit('close')}}},[_c('iframe',{staticStyle:{"width":"80%","height":"180px"},attrs:{"src":_vm.transistorUrl,"width":"80%","height":"180","frameborder":"0","scrolling":"no","seamless":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }